export const PRIVATE_WORKSPACE = 'private';
export const SHARED_WORKSPACE = 'shared';
export const TEAM_WORKSPACE = 'team';

/**
 * The team workspace display name is used for things like page header
 * titles. It's commonly used to change the Personal Library header to
 * Team Library when the team workspace is selected.
 */
export const TEAM_WORKSPACE_DISPLAY_NAME = 'Team Library';
export const SHARED_WORKSPACE_DISPLAY_NAME = 'Shared Library';
export const PRIVATE_WORKSPACE_DISPLAY_NAME = 'Personal Library';

export const ALL_WORKSPACES = [
  PRIVATE_WORKSPACE,
  SHARED_WORKSPACE,
  TEAM_WORKSPACE,
];

export const WORKSPACE_CREATION_METHOD_ADMIN_TOOL = 'admin_tool';
export const WORKSPACE_CREATION_METHOD_SIGNUP_FLOW = 'signup_flow';
export const WORKSPACE_CREATION_METHOD_CREATE_WORKSPACE_MODAL =
  'create_workspace_modal';

/**
 * Reasons for account suspension
 * @readonly
 * @enum {String}
 */
export const ACCOUNT_SUSPENSION_REASONS = {
  SUSPENDED_NON_PAYMENT: 'suspended_non_payment',
};
